<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import BackLinkView from "../Link/BackLinkView.svelte";
    import TipsMessageAreaView from "../Message/TipsMessageAreaView.svelte";

    const dispatcher = createEventDispatcher();

    export let title;

    export let backLinkUrl = null;
    export let backLinkTargetName = 'ひとつ上';

    export let description = null;


    onMount(() => {
    });


</script>

<div class="heading-title-view">

    <div class="left-area">
        <div class="title-back-link-area">
            {#if backLinkUrl != null}
                <div class="back-link-area">
                    <BackLinkView url={backLinkUrl} targetName={backLinkTargetName}/>
                </div>
            {/if}
            <div class="title">
                { title }
            </div>
        </div>

        {#if description != null}
            <div class="description-area">
                <TipsMessageAreaView>
                    { description }
                </TipsMessageAreaView>
            </div>
        {/if}

        <slot name="bottom"/>
    </div>

    <div class="right-area">
        <slot name="right"/>
    </div>

</div>

<style lang="scss">
    .heading-title-view {
        display: flex;
        align-items: flex-start;
        padding-bottom: 32px;

        .left-area {
            flex-grow: 1;

            .title-back-link-area {
                .title {
                    font-size: 2em;
                }
            }
        }

        .right-area {

        }

    }
</style>